import type { RefObject } from 'react'
import type { RxDocument } from 'rxdb'

import type { Card } from '~/db/types'

import type { EditCardProps } from '../edit-card/types'

export type StatelessListProps = {
  cards: RxDocument<Card>[]
  lastInsertedId: string | null
  activeCardId?: string
  activeCardRef?: RefObject<HTMLDivElement | null>
  className?: string
  ref?: RefObject<HTMLDivElement | null>
} & Pick<
  EditCardProps<RxDocument<Card>>,
  | 'onExamplesChange'
  | 'onLearnTextChange'
  | 'onPronunciationChange'
  | 'onRefresh'
  | 'onRemove'
  | 'onSourceTextChange'
  | 'onSnoozeForCount'
  | 'onUnsnooze'
>

export const columns = [1, 2] as const
export type ColumnCount = (typeof columns)[number]
